module.exports = __webpack_public_path__ + "static/media/c2.74b359d0.jpg";